import { Button } from '@ophelos/ui/components/button';
import { Minus, Plus } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

interface PaymentCountStepperProps {
  count: number;
  onChange: (count: number) => void;
  min: number;
  max: number;
  disabled?: boolean;
}

export function PaymentCountStepper({ count, onChange, min, max, disabled = false }: PaymentCountStepperProps) {
  const { t } = useTranslation();
  return (
    <div className="p-2 rounded-xl flex items-center justify-between px-3 bg-card border shadow-xs border-border-heavy w-full">
      <Button
        variant="subtle"
        size="icon-sm"
        className="rounded-full"
        onClick={() => onChange(Math.max(count - 1, min))}
        disabled={disabled || count <= min}
        aria-label={t('paymentPlan.decreasePaymentCount')}
      >
        <Minus className="size-4" />
      </Button>
      <span className="text-2xl font-bold tabular-nums text-accent-foreground" aria-live="polite">
        {count}
      </span>
      <Button
        variant="subtle"
        size="icon-sm"
        className="rounded-full"
        onClick={() => onChange(Math.min(count + 1, max))}
        disabled={disabled || count >= max}
        aria-label={t('paymentPlan.increasePaymentCount')}
      >
        <Plus className="size-4" />
      </Button>
    </div>
  );
}
